var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Background jobs are a local-only mock (no backend endpoint). Self-contained
// IndexedDB so this feature does not depend on the collections admin api.
var DB_NAME = "admin_jobs_db";
var DB_VER = 1;
var STORE = "jobs";
var openAdminDB = function () {
    return new Promise(function (resolve, reject) {
        var req = indexedDB.open(DB_NAME, DB_VER);
        req.onupgradeneeded = function () {
            var db = req.result;
            if (!db.objectStoreNames.contains(STORE)) {
                db.createObjectStore(STORE, { keyPath: "id" });
            }
        };
        req.onsuccess = function () { return resolve(req.result); };
        req.onerror = function () { return reject(req.error); };
    });
};
var dbGetAll = function () { return __awaiter(void 0, void 0, Promise, function () {
    var db;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, openAdminDB()];
            case 1:
                db = _a.sent();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var req = db.transaction(STORE, "readonly").objectStore(STORE).getAll();
                        req.onsuccess = function () { var _a; return resolve((_a = req.result) !== null && _a !== void 0 ? _a : []); };
                        req.onerror = function () { return reject(req.error); };
                    })];
        }
    });
}); };
var dbGet = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var db;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, openAdminDB()];
            case 1:
                db = _a.sent();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var req = db.transaction(STORE, "readonly").objectStore(STORE).get(id);
                        req.onsuccess = function () { return resolve(req.result); };
                        req.onerror = function () { return reject(req.error); };
                    })];
        }
    });
}); };
var dbPut = function (job) { return __awaiter(void 0, void 0, Promise, function () {
    var db;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, openAdminDB()];
            case 1:
                db = _a.sent();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var req = db.transaction(STORE, "readwrite").objectStore(STORE).put(job);
                        req.onsuccess = function () { return resolve(); };
                        req.onerror = function () { return reject(req.error); };
                    })];
        }
    });
}); };
var wait = function (ms) {
    if (ms === void 0) { ms = 250; }
    return new Promise(function (r) { return setTimeout(r, ms); });
};
// In-memory tick handlers (mock job runners). Each job ticks on a setInterval
// until status reaches "done" or "failed".
var runningTimers = new Map();
var startMockRunner = function (jobId, totalTicks, tickMs, failChance) {
    if (tickMs === void 0) { tickMs = 700; }
    if (failChance === void 0) { failChance = 0.02; }
    if (runningTimers.has(jobId))
        return;
    var timer = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
        var job, t, t, nextProcessed, isDone, t;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dbGet(jobId)];
                case 1:
                    job = _a.sent();
                    if (!job || job.status === "done" || job.status === "failed") {
                        t = runningTimers.get(jobId);
                        if (t)
                            clearInterval(t);
                        runningTimers.delete(jobId);
                        return [2 /*return*/];
                    }
                    if (!(Math.random() < failChance)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dbPut(__assign(__assign({}, job), { status: "failed", error: "Mock failure: simulated chain error", updatedAt: new Date().toISOString() }))];
                case 2:
                    _a.sent();
                    t = runningTimers.get(jobId);
                    if (t)
                        clearInterval(t);
                    runningTimers.delete(jobId);
                    return [2 /*return*/];
                case 3:
                    nextProcessed = Math.min(job.total, job.processed + Math.ceil(totalTicks / 10) + 1);
                    isDone = nextProcessed >= job.total;
                    return [4 /*yield*/, dbPut(__assign(__assign({}, job), { status: isDone ? "done" : "running", processed: nextProcessed, updatedAt: new Date().toISOString() }))];
                case 4:
                    _a.sent();
                    if (isDone) {
                        t = runningTimers.get(jobId);
                        if (t)
                            clearInterval(t);
                        runningTimers.delete(jobId);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, tickMs);
    runningTimers.set(jobId, timer);
};
export var jobsAdminApi = {
    list: function () { return __awaiter(void 0, void 0, Promise, function () {
        var all;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, wait(150)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dbGetAll()];
                case 2:
                    all = _a.sent();
                    return [2 /*return*/, all.sort(function (a, b) { return b.createdAt.localeCompare(a.createdAt); })];
            }
        });
    }); },
    get: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, dbGet(id)];
        });
    }); },
    // Enqueue a new mock job. Optionally start ticking immediately.
    enqueue: function (_a) { return __awaiter(void 0, [_a], Promise, function (_b) {
        var now, job;
        var type = _b.type, total = _b.total, collectionId = _b.collectionId, auctionId = _b.auctionId, message = _b.message, _c = _b.startImmediately, startImmediately = _c === void 0 ? true : _c, _d = _b.tickMs, tickMs = _d === void 0 ? 700 : _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, wait(120)];
                case 1:
                    _e.sent();
                    now = new Date().toISOString();
                    job = {
                        id: crypto.randomUUID(),
                        type: type,
                        status: startImmediately ? "running" : "queued",
                        collectionId: collectionId,
                        auctionId: auctionId,
                        processed: 0,
                        total: total,
                        message: message,
                        createdAt: now,
                        updatedAt: now,
                    };
                    return [4 /*yield*/, dbPut(job)];
                case 2:
                    _e.sent();
                    if (startImmediately && total > 0)
                        startMockRunner(job.id, total, tickMs);
                    return [2 /*return*/, job];
            }
        });
    }); },
    // Force a job to a specific status (for testing / manual ops)
    setStatus: function (id, status, error) { return __awaiter(void 0, void 0, Promise, function () {
        var existing, updated, t;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dbGet(id)];
                case 1:
                    existing = _a.sent();
                    if (!existing)
                        throw new Error("Job \"".concat(id, "\" not found"));
                    updated = __assign(__assign({}, existing), { status: status, error: error, processed: status === "done" ? existing.total : existing.processed, updatedAt: new Date().toISOString() });
                    return [4 /*yield*/, dbPut(updated)];
                case 2:
                    _a.sent();
                    if (status === "done" || status === "failed") {
                        t = runningTimers.get(id);
                        if (t)
                            clearInterval(t);
                        runningTimers.delete(id);
                    }
                    return [2 /*return*/, updated];
            }
        });
    }); },
};
